import React from 'react';
import { SurroundingProducts } from '../../services/productsApi';
import ProductNavigationLink from './ProductNavigationLink';

interface ProductNavigationProps {
  products: SurroundingProducts;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & ProductNavigationProps>;

export const ProductNavigation: Props = ({ className, products, ...props }) => (
  <div className="container" {...props}>
    <div className="row">
      <div className="col-span-6 sm:col-span-5">
        {products.previous && <ProductNavigationLink product={products.previous} direction="previous" />}
      </div>

      <div className="col-span-6 sm:col-span-5 sm:col-start-8">
        {products.next && <ProductNavigationLink product={products.next} direction="next" />}
      </div>
    </div>
  </div>
);
